import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import SearchBar from '../datatable/SearchBar';
import RelationDataTable from '../datatable/RelationDataTable';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import {
  defaultRejectHandler,
  stringifyErrorMessage,
} from '../../utils/utility';
import {
  listVRFInZone,
  addVRFToZone,
  removeVRFFromZone,
} from '../../redux/zone/zone_vrf_actions';
import { searchVRFSystemByText } from '../../redux/vrf/vrf_system_actions';

// FRS 4.2.1 revision 20260826 (Q8) - วาง VRF System ทั้งระบบลงในโซน (1 แถว = 1 System,
// จำนวน Indoor ถูกกำหนดไว้แล้วที่ตัว System) — ไม่มีจำนวน/แก้ไขที่ระดับ placement อีกต่อไป
const summarizeIndoors = indoors =>
  (indoors || []).map(i => `${i.name} ×${i.quantity}`).join(', ') || '-';

export class VRFDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };
    this.state = { categoryOption: 'all' };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    this.props.listVRF(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      { all: null, public: true, private: false }[category],
    );
    this.setState({ categoryOption: category });
  }

  render() {
    const {
      zoneId,
      vrfList,
      filteredCount,
      isLoading,
      addVRF,
      removeVRF,
      isAdding,
      isRemoving,
      errorMessage,
      t,
    } = this.props;

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);

    const columns = [
      {
        Header: () => <b>{t('vrf system')}</b>,
        id: 'system_name',
        accessor: row => row.vrf_system.name,
        ...textColumn,
        entity: {
          list: (text, page) =>
            searchVRFSystemByText(text, page, zoneId).then(response =>
              response.data.map(system => ({
                label: system.name,
                value: system.id,
              })),
            ),
        },
      },
      {
        Header: () => <b>{t('outdoor unit')}</b>,
        id: 'outdoor_name',
        accessor: row => row.vrf_system.outdoor.name,
        ...textColumn,
        width: 150,
      },
      {
        Header: () => <b>{t('indoor units')}</b>,
        id: 'indoor_summary',
        accessor: row => summarizeIndoors(row.vrf_system.indoors),
        ...textColumn,
      },
      {
        Header: () => <b>COP</b>,
        id: 'cop',
        accessor: row => row.vrf_system.cop,
        Cell: cell => (cell.value == null ? t('pending') : cell.value),
        ...coeColumn,
        width: 90,
      },
      {
        Header: () => <b>{t('SEER')}</b>,
        id: 'seer',
        accessor: row => row.vrf_system.seer,
        Cell: cell => (cell.value == null ? '-' : cell.value),
        ...coeColumn,
        width: 90,
      },
    ];

    const relationship = {
      create: ({ entityId }) => addVRF(entityId, zoneId),
      delete: id => removeVRF(id),
      isCreating: isAdding,
      isDeleting: isRemoving,
    };

    return (
      <div style={{ backgroundColor: 'white' }}>
        <SearchBar
          onSearch={text =>
            this.updateSortFilter(text, null, this.state.categoryOption)
          }
        />
        <RelationDataTable
          columns={columns}
          data={vrfList}
          errorMessage={stringifyErrorMessage(errorMessage)}
          relationship={relationship}
          relationshipNameAccessor={item => item.vrf_system.name}
          onActionDelete={item =>
            this.setState({
              isShowDeleteModal: true,
              selectedItem: item.original,
            })
          }
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state =>
            this.updateSortFilter(
              this.search.filtered,
              state,
              this.state.categoryOption,
            )
          }
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  vrfList: state.zoneVRF.orderedIds.map(id => state.zoneVRF.objects[id]),
  isLoading: state.zoneVRF.isLoading,
  isAdding: state.zoneVRF.isCreating,
  isRemoving: state.zoneVRF.isDeleting,
  errorMessage: state.zoneVRF.errorMessage,
});

const mapDispatchToProps = (dispatch, ownedProps) => ({
  listVRF: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(
        listVRFInZone(
          pageSize,
          page,
          sorted,
          filtered,
          isPublic,
          ownedProps.zoneId,
        ),
      ),
    ),
  addVRF: (vrfSystemId, zoneId) =>
    defaultRejectHandler(dispatch(addVRFToZone(vrfSystemId, zoneId))),
  removeVRF: id => defaultRejectHandler(dispatch(removeVRFFromZone(id))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(VRFDataTable),
);



// WEBPACK FOOTER //
// ./src/components/zone/VRFDataTable.js